import React from "react";
import PropTypes from "prop-types";
import { Form, Button, Collapse, Row, Card, Modal, Statistic, message, Col, Spin, Input, Select, InputNumber } from "antd";
import { OrderedMap } from "immutable";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import {
    INPUT_TYPES, SECURITY_BASIS,
    RECOURSE_STRUCTURE, SECURITY_TYPES, BUSINESS_PRODUCT_TYPE, PROGRAM_TYPE
} from "constants/index";
import "styles/tabs.css";
import { STATE_STATUS } from "../constants";
import moment from "moment";

const { Panel } = Collapse;
const getFormFields = ({
    allFieldsDisabled,
}) =>
    new OrderedMap({
        recourse_structure: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.SELECT,
            label: "Recourse Structure",
            options: RECOURSE_STRUCTURE.map((value, label) => ({
                label,
                value: String(value)
            }))
                .toList()
                .toArray(),
            disabled: allFieldsDisabled,
            category: 1,
            col: 8
        },
        recourse_perc: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.TEXT,
            label: "Recourse %",
            disabled: allFieldsDisabled,
            category: 1,
            col: 8
        },
        days_of_guarantee_invocation: {
            className: "form-field fb-30 mr-3perc",
            label: "Days of Guarantee Invocation",
            type: INPUT_TYPES.TEXT,
            category: 1,
            col: 8
        },
        security_type: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.SELECT,
            label: "Security Type",
            options: SECURITY_TYPES.map((value, label) => ({
                label,
                value: String(value)
            }))
                .toList()
                .toArray(),
            disabled: allFieldsDisabled,
            category: 1,
            col: 8
        },
        security_basis: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.SELECT,
            label: "Security Basis",
            options: SECURITY_BASIS.map((value, label) => ({
                label,
                value: String(value)
            }))
                .toList()
                .toArray(),
            disabled: allFieldsDisabled,
            category: 1,
            col: 8
        },
        effective_date: {
            key: "effective_date",
            label: "Effective Date",
            disabled: true,
            dataIndex: "effective_date",
            type: INPUT_TYPES.DATE,
            className: "form-field fb-30 mr-3perc",
            col: 8
        },
        holdback_calculation_type: {
            label: "Holdback Type",
            className: "form-field fb-20 mr-3perc",
            type: INPUT_TYPES.RADIO,
            defaultValue: 1,
            options: [
                {
                    key: "security_perc",
                    value: 2,
                    label: "Holdback %"
                },
                {
                    key: "security_amount",
                    value: 1,
                    label: "Holdback Amount"
                }
            ],
            col: 24
        },
        security_perc: {
            key: "security_perc",
            label: "Holdback %",
            disabled: true,
            dataIndex: "security_perc",
            type: INPUT_TYPES.NUMBER,
            className: "form-field fb-30 mr-3perc",
            col: 8
        },
        security_amount: {
            key: "security_amount",
            label: "Holdback Amount",
            dataIndex: "security_amount",
            type: INPUT_TYPES.NUMBER,
            disabled: true,
            className: "form-field fb-30 mr-3perc",
            col: 8
        },
        is_churns_applicable: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.RADIO,
            label: "Churns Applicable",
            defaultValue: false,
            options: [
                {
                    key: "Yes",
                    value: true,
                    label: "Yes"
                },
                {
                    key: "No",
                    value: false,
                    label: "No"
                }
            ],
            disabled: allFieldsDisabled,
            category: 1,
            col: 8
        },
        number_of_churns: {
            className: "form-field fb-30 mr-3perc",
            label: "No. of Churns",
            type: INPUT_TYPES.NUMBER,
            category: 1,
            col: 8
        },
        pre_churn_db_security_perc: {
            className: "form-field fb-30 mr-3perc",
            label: "Pre Churn DB Security",
            type: INPUT_TYPES.TEXT,
            category: 1,
            col: 8
        },
    });


const getProfileLayout = data => new OrderedMap({
    business_product_name: {
        key: "business_product_name",
        label: "Business Product Name",
        value: Array.from(BUSINESS_PRODUCT_TYPE.entries()).find(([key, val]) => val === data?.product_type)?.[0],
        type: "CARD"
    },
    program_type: {
        key: "program_type",
        label: "Program Type",
        value: Array.from(PROGRAM_TYPE.entries()).find(([key, val]) => val === data?.program_type)?.[0],
        type: "card"
    },
    max_ticket_size_db: {
        key: "max_ticket_size_db",
        label: "Max Ticket Size Allowed(For DB)",
        value: `Rs.${Number(data?.proposed_max_ticket_size_in_lacs)} Cr.`,
        type: "card"
    },
});

class DBRiskControlForm extends React.Component {

    state = {
        formValues: Array.isArray(this.props.dbRiskFormDetail) ? [...this.props.dbRiskFormDetail] : [],
        showProductModal: false,
        selectedProfileData: {},
        dbRiskFormDetailState: this.props.dbRiskFormDetail || [],
        showNewProgramModal: false
    };
    formRef = React.createRef();
    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.dbRiskFormDetail !== this.props.dbRiskFormDetail && this.props.dbRiskFormDetail) {
            this.setState({ formValues: this.props.dbRiskFormDetail, dbRiskFormDetailState: this.props.dbRiskFormDetail });
        }
    }

    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    onValuesSubmit = (e, id, index) => {
        e.preventDefault();
        const fieldsInSection = Object.keys(this.props.form.getFieldsValue())
            .filter((key) => key.startsWith(`${index}.`)); // Get only the fields for this index
            const { program_type = null, proposed_max_ticket_size_in_lacs = null, proposed_program_size_in_cr = null } =
            Array.isArray(this.props.dbRiskFormDetail) ? this.props.dbRiskFormDetail[0] :
            this.props.dbRiskFormDetail;
            const validationFields = Object.keys(this.props.dbRiskFormDetail[index]);
        this.props.form.validateFields((err, data) => {
            let sectionData = data[index];
            const recourse_structure = !isNaN(sectionData.recourse_structure) ? Number(sectionData.recourse_structure)
                : RECOURSE_STRUCTURE.get(sectionData.recourse_structure);
            const security_type = !isNaN(sectionData.security_type) ? Number(sectionData.security_type) :
                SECURITY_TYPES.get(sectionData.security_type);
            const security_basis = !isNaN(sectionData.security_basis)
                ? Number(sectionData.security_basis)
                : SECURITY_BASIS.get(sectionData.security_basis);
            const security_perc = Number(sectionData.security_perc);
            const is_churns_applicable = sectionData.is_churns_applicable;
            const holdback_calculation_type = sectionData.holdback_calculation_type;
            const effective_date = recourse_structure ==  5 ? sectionData.effective_date : null;

            sectionData = {
                "mpa_approval_id": id,
                "company_id": Number(this.props.companyId),
                ...sectionData,
                recourse_structure,
                security_type,
                security_basis,
                program_type,
                proposed_max_ticket_size_in_lacs,
                // proposed_program_size_in_cr,
                security_perc,
                effective_date: effective_date ? moment(effective_date).format('YYYY-MM-DD') : null
            }
            const fieldsToCheck = Object.entries(sectionData)
                .filter(([key]) => 
                    !(
                        (recourse_structure === 3 && key === "recourse_perc") || 
                        (!is_churns_applicable && (key === 'pre_churn_db_security_perc' || key === 'number_of_churns')) ||
                        (holdback_calculation_type === 2 && key === 'security_amount') || 
                        (holdback_calculation_type === 1 && key === 'security_perc') ||
                        (recourse_structure !== 5 && key == 'effective_date')
                    )
                )
                .map(([_, value]) => value);
            if (fieldsToCheck.some(el => el === "" || el == null || el == undefined)) {
                message.error("All the fields are mandatory");
                return;
            }else{
                this.props.onValuesSubmit(sectionData)
            }
        });
    };

    formFields = getFormFields({
        allFieldsDisabled: this.props.loading,
    });

    handleFieldValueChange = (index, fieldName, value) => {
        const updatedValues = Array.isArray(this.state.formValues) ? [...this.state.formValues] : [];
        updatedValues[index] = {
            ...updatedValues[index],
            [fieldName]: value,
        };
        this.setState({ formValues: updatedValues }, () => {
            if (fieldName == "security_type" && value == 5) {
                const security_perc = `${index}.${'security_perc'}`;
                const security_amount = `${index}.${'security_amount'}`;
                this.props.form.setFieldsValue({
                    [security_perc]: null,
                    [security_amount]: null,
                })
            }

            if (fieldName == "holdback_calculation_type") {
                const security_perc = `${index}.${'security_perc'}`;
                const security_amount = `${index}.${'security_amount'}`;
                this.props.form.setFieldsValue({
                    [security_perc]: null,
                    [security_amount]: null,
                })
            }

            if (fieldName == 'is_churns_applicable') {
                const number_of_churns_field = `${index}.${'number_of_churns'}`;
                const pre_churn_db_security_perc = `${index}.${'pre_churn_db_security_perc'}`;
                this.props.form.setFieldsValue({
                    [number_of_churns_field]: null,
                    [pre_churn_db_security_perc]: null,
                })
            }
            if (fieldName == 'recourse_structure') {
                const recourse_perc = `${index}.${'recourse_perc'}`;
                const pre_churn_db_security_perc = `${index}.${'pre_churn_db_security_perc'}`;
                const effective_date = `${index}.${'effective_date'}`;

                if (value == 3) {
                    this.props.form.setFieldsValue({
                        [recourse_perc]: null,
                    })
                } else if (value == 4) {
                    this.props.form.setFieldsValue({
                        [recourse_perc]: null,
                        [pre_churn_db_security_perc]: null,
                    })
                }
                else if (value == 5) {
                    this.props.form.setFieldsValue({
                        [recourse_perc]: '100',
                        [pre_churn_db_security_perc]: null,
                        [effective_date]: null                        
                    })
                }
            }
        })
    }

    handleAddProgramType = () => {
        this.setState({showNewProgramModal: true})
    };
    handleClose = () => {
        this.setState({ showProductModal: false });
    }
    submitNewProgramDetails = (e) => {
        e.preventDefault();
        const fields_to_validate = ["new_program_type", "new_max_ticket_size_db", "new_business_product_name", "new_proposed_program_size"];
        this.props.form.validateFields([...fields_to_validate], (err, values) => {
            if (!err) {
                const body =
                    {
                        company_id: this.props.companyId,
                        mpa_approval_id: null,
                        product_type: !isNaN(values['new_business_product_name']) ? values['new_business_product_name'] : BUSINESS_PRODUCT_TYPE.get(values['new_business_product_name']),
                        program_type: !isNaN(values['new_program_type']) ? values['new_program_type'] : PROGRAM_TYPE.get(values['new_program_type']),
                        proposed_max_ticket_size_in_lacs: values["new_max_ticket_size_db"],
                        proposed_program_size_in_cr: values['new_proposed_program_size'],
                    }
                if (Object.values(values).some(el => el === "" || el == null || el == undefined)) {
                    message.error("All the fields are mandatory");
                    return;
                }else{
                    this.props.onValuesSubmit(body)
                    this.setState({
                        showNewProgramModal: false,
                    });
                }
            }
        });
    }
    
    submitProductDetails = (e, profile_data) => {
        e.preventDefault();
        this.props.form.validateFields(['max_ticket_size_db', 'program_type'], (err, values) => {
            if (!err) {
                const product_details = {
                    mpa_approval_id: profile_data.id || null,
                    proposed_max_ticket_size_in_lacs: values["max_ticket_size_db"],
                    program_type: !isNaN(values['program_type']) ? values['program_type'] : PROGRAM_TYPE.get(values['program_type'])
                }
                const body =  {
                        ...profile_data,
                        company_id: this.props.companyId,
                        ...product_details
                    }
                this.setState({
                    showProductModal: false,
                });
                this.props.onValuesSubmit(body, 'edit_product_details')
            }
        });
    }
    product_details = (profile_data) => {
        return (
            <Col className={"d-flex flex-column w-100"}>
                <Col className={"d-flex flex-row align-items-center w-100 mb-10"}>
                    <Row gutter={24} className="w-100 d-flex">
                        {
                            getProfileLayout(profile_data).map(_ =>
                            (
                                <Col key={_.key} span={_.span} className="w-100">
                                    <Statistic
                                        valueStyle={{
                                            fontSize: "16px",
                                            fontWeight: 500
                                        }}
                                        title={_.label}
                                        value={_.value || "--"}
                                    />
                                </Col>
                            )
                            ).toList()
                        }
                        <Button type="primary" onClick={() => this.setState({ showProductModal: !this.state.showProductModal, selectedProfileData: profile_data })}>Edit</Button>
                    </Row>
                </Col>
            </Col>
        )
    }

    openProductDetailsModal = (_) =>{
        return(
            <Modal
                    closable={true}
                    destroyOnClose={true}
                    title="Edit Product Details"
                    visible={this.state.showProductModal}
                    onCancel={() => this.setState({ showProductModal: false })}
                    centered={true}
                    footer={[
                        <Button key="submit" onClick={() => this.setState({ showProductModal: false })} >
                            Cancel
                        </Button>,
                        <Button key="back" type={"primary"} onClick={(e) => this.submitProductDetails(e, this.state.selectedProfileData)}>
                            Submit
                        </Button>,
                    ]}
                >
                    <div className="d-flex justify-content-center align-items-center" style={{ width: "100%" }}>
                        <Form onSubmit={this.submitProductDetails} layout="vertical" className="d-flex flex-column justify-content-center w-100" style={{ maxWidth: "500px" }}>
                            <h4>Business Product Name</h4>
                            <Form.Item>
                                {this.props.form.getFieldDecorator('business_product_name', {
                                    initialValue: Array.from(BUSINESS_PRODUCT_TYPE.entries()).find(([key, val]) => val === this.state.selectedProfileData?.product_type)?.[0],
                                })(
                                    this.state.selectedProfileData?.id ? <Input
                                        style={{ width: "50%" }}
                                        disabled
                                        placeholder="Business Product Name"
                                    /> :
                                        <Select style={{ width: "50%" }} placeholder="Program Type">
                                            {Array.from(BUSINESS_PRODUCT_TYPE.entries()).map(([label, value]) => (
                                                <Select.Option value={value} key={value}>
                                                    {label}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                )}
                            </Form.Item>
                            <h4>Program Type</h4>
                            <Form.Item>
                                {this.props.form.getFieldDecorator('program_type', {
                                    initialValue: Array.from(PROGRAM_TYPE.entries()).find(([key, val]) => val === this.state.selectedProfileData?.program_type)?.[0],
                                    rules: [{ required: true, message: 'Please fill the field!' }],
                                })(
                                    <Select style={{ width: "50%" }} placeholder="Product Type">
                                        <Select.Option value={1} key={"1"}>Primary</Select.Option>
                                        <Select.Option value={2} key={"2"}>Secondary</Select.Option>
                                    </Select>
                                )}
                            </Form.Item>
                            <h4>Max. Ticket Size(DB)</h4>
                            <Form.Item>
                                {this.props.form.getFieldDecorator('max_ticket_size_db', {
                                    initialValue: this.state.selectedProfileData?.proposed_max_ticket_size_in_lacs,
                                    rules: [{ required: true, message: 'Please fill the field!' }],
                                })(
                                    <InputNumber
                                        style={{ width: "50%" }}
                                        placeholder="Max. Ticket Size(DB)"
                                    />,
                                )}
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
        )
    }
    getCompanyForm = () => {
        if (this.props.dbRiskFormDetailStatus === STATE_STATUS.FETCHING) {
            return (
                <div className={"d-flex flex-row justify-content-center"}>
                    <Spin />
                </div>
            );
        }
        return (
            <Spin spinning={this.props.dbRiskFormDetailStatus === STATE_STATUS.UPDATING}>
                <Card className={"no-shadow border-none"}>
                    <div className="d-flex justify-content-space-between">
                    <h3 className={"pt-5 pb-5 mb-5"}>{"Product Details"}</h3>
                        <Button type="primary" onClick={this.handleAddProgramType} className="mb-10">
                            Add Program Type
                        </Button>
                    </div>
                    <Modal
                closable={true}
                destroyOnClose={true}
                title="Add New Program"
                visible={this.state.showNewProgramModal}
                onCancel={() => {
                    this.setState({ showNewProgramModal: false })}
                }
                centered={true}
                footer={[
                    <Button key="submit" onClick={() => {
                        this.setState({ showNewProgramModal: false })} 
                        }>
                        Cancel
                    </Button>,
                    <Button key="back" type={"primary"} onClick={(e) => this.submitNewProgramDetails(e, this.state.selectedProfileData)}>
                        Submit
                    </Button>,
                ]}
            >
                <div className="d-flex justify-content-center align-items-center" style={{ width: "100%" }}>
                    <Form onSubmit={this.submitNewProgramDetails} layout="vertical" className="d-flex flex-column justify-content-center w-100" style={{ maxWidth: "500px" }}>
                        <h4>New Business Product Name</h4>
                        <Form.Item>
                            {this.props.form.getFieldDecorator('new_business_product_name', {
                            })(
                                    <Select style={{ width: "50%" }} placeholder="Program Type">
                                        {Array.from(BUSINESS_PRODUCT_TYPE.entries()).map(([label, value]) => (
                                            <Select.Option value={value} key={value}>
                                                {label}
                                            </Select.Option>
                                        ))}
                                    </Select>
                            )}
                        </Form.Item>
                        <h4>New Program Type</h4>
                        <Form.Item>
                            {this.props.form.getFieldDecorator('new_program_type', {
                                rules: [{ required: true, message: 'Please fill the field!' }],
                            })(
                                <Select style={{ width: "50%" }} placeholder="Product Type">
                                    <Select.Option value={1} key={"1"}>Primary</Select.Option>
                                    <Select.Option value={2} key={"2"}>Secondary</Select.Option>
                                </Select>
                            )}
                        </Form.Item>
                        <h4>Max. Ticket Size(DB)</h4>
                        <Form.Item>
                            {this.props.form.getFieldDecorator('new_max_ticket_size_db', {
                                rules: [{ required: true, message: 'Please fill the field!' }],
                            })(
                                <InputNumber
                                    style={{ width: "50%" }}
                                    placeholder="Max. Ticket Size(DB)"
                                />,
                            )}
                        </Form.Item>
                        <h4>New Proposed Proposed Program Size</h4>
                        {<Form.Item>
                            {this.props.form.getFieldDecorator('new_proposed_program_size', {
                                rules: [{ required: true, message: 'Please fill the field!' }],
                            })(
                                <InputNumber
                                    style={{ width: "50%" }}
                                    placeholder="Proposed Program Size(crores)"
                                />,
                            )}
                        </Form.Item>}
                    </Form>
                </div>
            </Modal>
                    <div className={"d-flex flex-row align-items-center flex-wrap w-100"}>
                        {
                            this.state.dbRiskFormDetailState.length > 0 &&
                            this.state.dbRiskFormDetailState.map((_, index) => (
                                <Row className="w-100">
                                    <Collapse
                                        className="ant-d-collapse-padding custom-header-antd"
                                        bordered={false}
                                        expandIconPosition={"right"}
                                        accordion
                                    >
                                        <Panel
                                            header={
                                                this.product_details(_)
                                            }
                                            key={index}
                                        >
                                            <div className="mb-10">
                                                <h3>DB Background</h3>
                                                <h4>Promotor and Company Information</h4>
                                            </div>
                                            {this.openProductDetailsModal(_)}
                                            <Form key={_.id} id={_.id} onSubmit={(e) => this.onValuesSubmit(e, _.id, index)}>
                                                <div
                                                    key={`User-${_?.id}`}
                                                    className={"d-flex flex-row align-items-center flex-wrap w-100 mb-10"}
                                                >
                                                    {this.formFields.map((field, fieldName) => {
                                                        const recourse_structure = this.props.form.getFieldValue(`${index}.recourse_structure`);

                                                        if (!this.props.disableFields) {
                                                            if (fieldName == "security_perc") {
                                                                const holdback_calculation_type = this.props.form.getFieldValue(`${index}.holdback_calculation_type`);
                                                                const security_type = this.props.form.getFieldValue(`${index}.security_type`);
                                                                if (holdback_calculation_type == 2) {
                                                                    field.disabled = false;
                                                                    field.rules = [
                                                                        {
                                                                            pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                                                                            message: "Input must be between 0 and 100"
                                                                        }
                                                                    ];
                                                                } else {
                                                                    field.disabled = true;
                                                                    field.rules = [{
                                                                        required: false
                                                                    }];
                                                                }
                                                                if (security_type == 5) {
                                                                    field.disabled = true;
                                                                    field.rules = [{
                                                                        required: false
                                                                    }];
                                                                }
                                                            }
                                                            if (fieldName == "security_amount") {
                                                                const holdback_calculation_type = this.props.form.getFieldValue(`${index}.holdback_calculation_type`);
                                                                const security_type = this.props.form.getFieldValue(`${index}.security_type`);

                                                                if (holdback_calculation_type == 2) {
                                                                    field.disabled = true;
                                                                    field.rules = [{
                                                                        required: false
                                                                    }];
                                                                } else {
                                                                    field.disabled = false;
                                                                    field.rules = [
                                                                        {
                                                                            pattern: /^(?:\d*\.)?\d+$/,
                                                                            message: "Please enter a valid number"
                                                                        }
                                                                    ];
                                                                }
                                                                if (security_type == 5) {
                                                                    field.disabled = true;
                                                                    field.rules = [{
                                                                        required: false
                                                                    }];
                                                                }
                                                            }

                                                            if (fieldName == "holdback_calculation_type") {
                                                                const security_type = this.props.form.getFieldValue(`${index}.security_type`);
                                                                if (security_type == 5) {
                                                                    field.disabled = true;
                                                                }
                                                            }

                                                            if (fieldName === "recourse_perc") {
                                                                const recourse_structure = this.props.form.getFieldValue(`${index}.recourse_structure`);
                                                                field.type = INPUT_TYPES.TEXT;
                                                                field.disabled = false;
                                                                field.rules = [
                                                                    {
                                                                        pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                                                                        message: "Input must be between 0 and 100"
                                                                    }
                                                                ];

                                                                if (recourse_structure == "NIL Recourse" || recourse_structure == 3) {
                                                                    field.disabled = true;
                                                                    field.rules = [{ required: false }];
                                                                }

                                                                if (recourse_structure == "50-50 Risk Sharing" || recourse_structure == 4) {
                                                                    field.type = INPUT_TYPES.SELECT;
                                                                    field.options = Array.from({ length: 10 }, (_, i) => ({
                                                                        label: `${(i + 1) * 10}`,
                                                                        value: (i + 1) * 10
                                                                    }));
                                                                }
                                                            }


                                                            if (['pre_churn_db_security_perc'].includes(fieldName)) {
                                                                field.type = INPUT_TYPES.INPUT;
                                                                field.options = undefined;
                                                                field.disabled = false;
                                                                const recourse_perc_value = this.props.form.getFieldValue(`${index}.recourse_perc`);
                                                                const is_churns_applicable = this.props.form.getFieldValue(`${index}.${'is_churns_applicable'}`);
                                                                const startValue = Math.ceil((recourse_perc_value + 1) / 10) * 10;
                                                                if (recourse_structure == 4 || recourse_structure == "50-50 Risk Sharing") {
                                                                    field.type = INPUT_TYPES.SELECT;
                                                                    field.options = Array.from({ length: (100 - startValue) / 10 + 1 }, (_, i) => ({
                                                                        label: (startValue + (i * 10)).toString(),
                                                                        value: startValue + (i * 10)
                                                                    }));
                                                                }else if(is_churns_applicable == false){
                                                                    field.disabled = true;
                                                                    field.type = INPUT_TYPES.TEXT;
                                                                }else {
                                                                    field.type = INPUT_TYPES.TEXT;
                                                                    field.options = [];
                                                                    field.disabled = false;
                                                                }
                                                            }
                                                            if(fieldName === "effective_date"){
                                                                const recourse_structure = this.props.form.getFieldValue(`${index}.${'recourse_structure'}`);
                                                                if(recourse_structure == "100-0 Risk Sharing" || recourse_structure == 5){
                                                                    field.disabled = false
                                                                    field.rules = [{ required: true }];
                                                                }else{
                                                                    field.disabled = true
                                                                    field.rules = [{ required: false }];
                                                                }
                                                            }
                                                            if (['number_of_churns'].includes(fieldName)) {
                                                                const is_churns_applicable = this.props.form.getFieldValue(`${index}.${'is_churns_applicable'}`);
                                                                if(is_churns_applicable == false){
                                                                    field.disabled = true;
                                                                    field.type = INPUT_TYPES.TEXT;
                                                                }else {
                                                                    field.type = INPUT_TYPES.TEXT;
                                                                    field.options = [];
                                                                    field.disabled = false;
                                                                }
                                                            }
                                                        }

                                                        return <Col span={field.col}>{this.fieldGenerator(
                                                            `${index}.${fieldName}`,
                                                            {
                                                                ...field,
                                                            },
                                                            this.getValidateStatus(""),
                                                            (e) => this.handleFieldValueChange(index, fieldName, (field.type == "SELECT" ? e : e.target?.value)),
                                                            true
                                                        )()}</Col>;
                                                    }).toList()}
                                                </div>
                                                    <div className={"w-20"}>
                                                        <Button type="primary" block htmlType="submit">Submit</Button>
                                                    </div>
                                            </Form>
                                        </Panel>
                                    </Collapse>
                                </Row>
                            ))
                        }
                    </div>
                </Card>
            </Spin>
        )
    };

    render() {
        return (
            <React.Fragment>
                <div className={"form-row align-items-center"}>
                    <div className={"w-100 pt-10"}>
                        {this.getCompanyForm()}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

DBRiskControlForm.propTypes = {
    form: PropTypes.object,
    onValuesSubmit: PropTypes.func,
    loading: PropTypes.bool,
    disableFields: PropTypes.bool,
    companyId: PropTypes.string,
};

export default Form.create({
    mapPropsToFields: ({ dbRiskFormDetail }) => {
        const dbRiskFormDetailNew = Array.isArray(dbRiskFormDetail) ? dbRiskFormDetail : dbRiskFormDetail;
        if (!Array.isArray(dbRiskFormDetailNew)) return {};
        return dbRiskFormDetailNew?.reduce((acc, value, index) => {

            const mappedFields = Object.entries(value).reduce((fieldAcc, [key, fieldValue]) => {
                let transformedValue = fieldValue;
                if (key === 'recourse_perc') {
                    transformedValue = Number(fieldValue) || '';
                }
                if (key === 'recourse_structure') {
                    const keyForValue = Array.from(RECOURSE_STRUCTURE.entries()).find(([key, val]) => val === fieldValue)?.[0];
                    transformedValue = keyForValue || '';
                }
                if (key === 'security_type') {
                    const keyForValue = Array.from(SECURITY_TYPES.entries()).find(([key, val]) => val === fieldValue)?.[0];
                    transformedValue = keyForValue || '';
                }
                if (key === 'security_perc') {
                    transformedValue = Number(transformedValue) || null;
                }
                if (key === 'security_basis') {
                    const keyForValue = Array.from(SECURITY_BASIS.entries()).find(([key, val]) => val === fieldValue)?.[0];
                    transformedValue = keyForValue || '';
                }
                if (key === "holdback_calculation_type" && [null, "" , 0].includes(transformedValue)) {
                        transformedValue = 1
                }
                if (key === 'effective_date') {
                    transformedValue = fieldValue ? moment(fieldValue, "YYYY-MM-DD") : '';
                }
                fieldAcc[key] = Form.createFormField({ value: transformedValue });
                return fieldAcc;
            }, {});

            acc[index] = mappedFields;
            return acc;
        }, {});
    }
})(DBRiskControlForm);
